import get from 'lodash/get';
import { useQuery } from '@apollo/client/react';
import { ProjectTypesDocument } from 'graphql/generated/graphql';

const useGetProjectTypes = (projectId: string) => {
  const { data, loading } = useQuery(ProjectTypesDocument, { variables: { projectId } });
  const type = get(data, 'projectTypes.type', null);
  const plannedProjectType = get(data, 'projectTypes.planned_project_type', null);
  return { type, plannedProjectType, loading };
};

export default useGetProjectTypes;
